import { ServiceLanding, ServiceLandingUrlSlugEnum } from '@rover/rsdk/src/apiClient/latest';

export default function serviceLandingFactory(): ServiceLanding {
  return {
    h1: '',
    h2: '',
    seoTitle: '',
    seoMetaDescription: '',
    countryCode: 'US',
    serviceLandingUrlSlug: ServiceLandingUrlSlugEnum['dog-boarding'],
    translatedServiceLandingUrlSlug: '',
  };
}
